import { trackingTopics, topicCloud } from "@/mocks/kanliao";

export default function TopicZone() {
  const [followed, setFollowed] = useState<number[]>([0, 1]);

  const toggle = (i: number) =>
    setFollowed((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));

  return (
    <section id="tracking" className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-focus-3-fill" />
              TRACKING · 追更
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              正在追 · 话题进度墙
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              挑一个在蹲的话题，更新进度一眼看清，5看料 替你盯着每一话。
            </p>
          </div>
          <a
            href="#scoop"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            全部追更
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {trackingTopics.map((t, i) => {
            const isFollowed = followed.includes(i);
            return (
              <article
                key={t.tag}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative h-44 w-full overflow-hidden sm:h-48">
                  <img
                    src={t.image}
                    alt={t.name}
                    title={t.name}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] font-semibold text-background-50 backdrop-blur">
                    <i className="ri-fire-fill text-accent-400" />
                    #{t.heat}
                  </span>
                  <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-semibold text-background-50">
                    {t.label}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{t.name}</h3>
                  <p className="mt-1 text-[13px] leading-relaxed text-foreground-600">{t.comment}</p>
                  <div className="mt-4 flex items-center justify-between text-[12px] text-foreground-500">
                    <span>{t.tag}</span>
                    <span className="font-medium text-foreground-700">{t.ep}</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                      style={{ width: `${t.pct}%` }}
                    />
                  </div>
                  <div className="mt-4 flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => toggle(i)}
                      className={
                        "inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-semibold transition-colors " +
                        (isFollowed
                          ? "bg-background-200 text-foreground-700"
                          : "bg-primary-500 text-background-50 hover:bg-primary-600")
                      }
                    >
                      <i className={isFollowed ? "ri-check-double-line" : "ri-add-line"} />
                      {isFollowed ? "已关注" : "跟追"}
                    </button>
                    <button
                      type="button"
                      className="inline-flex cursor-pointer items-center justify-center gap-1 rounded-md border border-background-200 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-background-100"
                    >
                      <i className="ri-chat-3-line" />
                      蹲评
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-50 px-4 py-4 md:px-6">
          <div className="flex flex-wrap items-center gap-3">
            <span className="flex items-center gap-1.5 whitespace-nowrap text-sm font-bold text-foreground-950">
              <i className="ri-hashtag text-accent-600" />
              热议话题墙
            </span>
            <span className="text-[11px] text-foreground-500">去蹲的人越多，越排前面</span>
          </div>
          <div className="mt-4 flex gap-2.5 overflow-x-auto pb-1 no-scrollbar">
            {topicCloud.map((c) => (
              <a
                key={c.name}
                href="#scoop"
                className="group flex shrink-0 flex-col rounded-md border border-background-200 bg-background-100 px-4 py-2 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="whitespace-nowrap text-[13px] font-medium text-foreground-900">
                  {c.name}
                </span>
                <span className="whitespace-nowrap text-[11px] text-foreground-500">
                  {c.type} · {c.count} 在蹲
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}